/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontaktePlay
 */
export interface FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontaktePlay {
    /**
     * 
     * @type {number}
     * @memberof FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontaktePlay
     */
    AppId: number;
}

/**
 * Check if a given object implements the FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontaktePlay interface.
 */
export function instanceOfFxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontaktePlay(value: object): value is FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontaktePlay {
    if (!('AppId' in value) || value['AppId'] === undefined) return false;
    return true;
}

export function FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontaktePlayFromJSON(json: any): FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontaktePlay {
    return FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontaktePlayFromJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontaktePlayFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontaktePlay {
    if (json == null) {
        return json;
    }
    return {
        
        'AppId': json['AppId'],
    };
}

export function FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontaktePlayToJSON(json: any): FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontaktePlay {
    return FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontaktePlayToJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontaktePlayToJSONTyped(value?: FxGamesLibWebPlatformDataOptionsPlatformDataOptionsVkontaktePlay | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AppId': value['AppId'],
    };
}

